import React from 'react';
import './style.scss';
import RenderSvgIcon from '../../RenderSvgIcon';


const wrapStyleArrow = {
  paddingRight: 3,
  width: 24,
  height: 24,
  color: 'var(--text-secondary)',
  fill: 'currentColor',
  cursor: 'pointer',
};

const Index = ({ open, setOpen, ...props }) => {

  const isExpanded = !!open;

  return (
    <div className={['d-act-button', `d-menu-${isExpanded ? 'opened' : 'closed'}`].join(' ')}
         onClick={() => setOpen(!open)}>
      <RenderSvgIcon
        name={isExpanded ? 'SVG_close_icon' : 'SVG_top_menu_burger'}
        style={wrapStyleArrow}
        className={'d-svg'}
      />
      {!open && <span style={{ top: 22 }}>MENU</span>}
    </div>
  );
};

export default Index;
